export type IndustryType = 'default' | 'kindergarten';

export interface BoxTemplate {
  name: string;
  shortDescription: string;
  description: string;
}

export interface HeaderTemplate {
  title: string;
  subtitle: string;
}

type BoxType = 'voice' | 'thanks' | 'theme';

const HEADER_TEMPLATES: Record<IndustryType, HeaderTemplate> = {
  default: {
    title: 'あなたの声が、職場をより良くします',
    subtitle: '匿名で安心して投稿できます。あなたの声が会社の改善につながります。',
  },
  kindergarten: {
    title: 'みなさんの声で、園がもっとあたたかくなります',
    subtitle: '匿名で安心してご利用いただけます。\nみなさんの声を、より良い園づくりに活かしていきます。',
  },
};

export function getHeaderTemplate(
  industryType: IndustryType | string | undefined | null
): HeaderTemplate {
  const key: IndustryType =
    industryType === 'kindergarten' ? 'kindergarten' : 'default';
  return HEADER_TEMPLATES[key];
}

const TEMPLATES: Record<IndustryType, Record<BoxType, BoxTemplate>> = {
  default: {
    voice: {
      name: 'アイデアボックス',
      shortDescription: '改善提案や意見を投稿',
      description: '職場の改善提案や意見を匿名で投稿。あなたの声が会社を変える第一歩に。',
    },
    thanks: {
      name: 'サンクスボックス',
      shortDescription: '感謝の気持ちを伝える',
      description: '同僚への感謝を伝えましょう。小さな「ありがとう」が職場の雰囲気を明るくします。',
    },
    theme: {
      name: 'テーマボックス',
      shortDescription: '今月のテーマに投稿',
      description: '今月のテーマについて意見を共有。みんなで考えることで新しいアイデアが生まれます。',
    },
  },
  kindergarten: {
    voice: {
      name: '気づきボックス',
      shortDescription: '気づきや提案を投稿',
      description: '園生活の中で気になったことや、「こうなったらいいな」をお聞かせください。',
    },
    thanks: {
      name: 'ひとことボックス',
      shortDescription: '感謝の気持ちを伝える',
      description: '先生へのメッセージや、日々の出来事など、気軽にお話しください。',
    },
    theme: {
      name: '聞かせてボックス',
      shortDescription: '今月のテーマに投稿',
      description: '園からの質問について、みなさんの声をお聞かせください。',
    },
  },
};

export function getBoxTemplate(
  industryType: IndustryType | string | undefined | null,
  boxType: BoxType
): BoxTemplate {
  const key: IndustryType =
    industryType === 'kindergarten' ? 'kindergarten' : 'default';
  return TEMPLATES[key][boxType];
}

export const INDUSTRY_TYPE_LABELS: Record<IndustryType, string> = {
  default: '一般企業',
  kindergarten: '幼稚園・保護者',
};
